module.exports = __webpack_public_path__ + "media/images/index/care_01_full-0fb28853da59f248db7f7ceeb9dc9d28.jpg";